import React from 'react';
import Dotdotdot from 'react-dotdotdot';

import BackgroundImage from '../../BackgroundImage';
import StatsigLink from '../../Links/StatsigLink';
import { useStatsig } from '../../hooks/useStatsig';
import config from '../../../../config';

import styles from './paidHitClub.scss';

const PaidHitClubCard = props => {
    const { featureGates } = useStatsig();
    const {
        force = {},
        forceCardView,
        paidHitClub,
        onClick,
        coreUITypes,
        'data-testid': dataTestId,
    } = props;

    const {
        id,
        name,
        location,
        clubProfileImages,
        playerProfile,
        singlesUtrDisplay,
    } = paidHitClub;

    const locationValue = location && location.display ? location.display : '';
    const descriptionItems = [locationValue];
    const description = descriptionItems.join(' \u00B7 ');

    const { playerExperienceTypes = [], coachingExperienceTypes = [] } = coreUITypes || {};
    const playingExperience = playerProfile?.experienceStatus && playerProfile?.experienceTypeId ? `${playerProfile.experienceStatus.charAt(0)?.toUpperCase() + playerProfile.experienceStatus.slice(1)} ${playerExperienceTypes.find(type => type.id === playerProfile.experienceTypeId)?.label}` : '';
    const coachingExperience = playerProfile?.coachingExperienceStatus && playerProfile?.coachingExperienceTypeId ? `${playerProfile.coachingExperienceStatus.charAt(0)?.toUpperCase() + playerProfile.coachingExperienceStatus.slice(1)} ${coachingExperienceTypes.find(type => type.id === playerProfile.coachingExperienceTypeId)?.label}` : '';
    const isCardView = forceCardView || (force && force.cardView);

    const toShowPaidHitAvailability = playerProfile?.paidHitAvailability ? playerProfile.paidHitAvailability.filter(a => a.isAvailable) : [];
    const singlesRating = singlesUtrDisplay === 0 ? '' : singlesUtrDisplay;

    const PaidHitAvailabilityContent = (prop) => (
        <>
            <li style={{ listStyle: 'none' }} className="show-ellipsis" data-testid={dataTestId && `${dataTestId}.availability-${prop.day}`}>
                <b data-testid={dataTestId && `${dataTestId}.availability-${prop.day}.day`}>{prop.day.charAt(0)?.toUpperCase() + prop.day?.slice(1)}</b>&nbsp; {prop.availability}
            </li>
        </>
    );

    return (
        <StatsigLink
            gate={featureGates.CLUB_LINKS_REDIRECT}
            enabledTo={`${config.nextAppHost}/club/${id}`}
            disabledTo={`/clubs/${id}`}
            onClick={onClick}
            data-testid={dataTestId && `${dataTestId}.card-link`}
        >
            <div className={`utr-card club-card ${force && force.featured ? 'club-card-featured' : ''}`}>
                <div className={`list-view ${isCardView ? 'd-none' : 'd-none d-md-block'}`}>
                    <div className="d-flex">
                        <div className="flex-grow">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="column show-ellipsis">
                                        <div className="name show-ellipsis" data-testid={dataTestId && `${dataTestId}.desktop.name`}>{name}</div>
                                        <div className={`${styles.rating} show-ellipsis`}>
                                            <span data-testid={dataTestId && `${dataTestId}.desktop.rating`}>
                                                {singlesRating || 'UR'} &nbsp;<span className="middle-dot" /> &nbsp;Singles
                                            </span>
                                        </div>
                                        <div className={`${styles.experience} show-ellipsis`}>
                                            <span data-testid={dataTestId && `${dataTestId}.desktop.playing-experience`}>{playingExperience || ''}</span>
                                            <span data-testid={dataTestId && `${dataTestId}.desktop.coaching-experience`}>{coachingExperience || ''}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-3">
                                    <div className={`${styles.paidHitAvailability} show-ellipsis`} data-testid={dataTestId && `${dataTestId}.desktop.availability`}>
                                        {playerProfile?.paidHitAvailability && playerProfile.paidHitAvailability.length > 0
                                            ? toShowPaidHitAvailability.length > 0 ? (
                                                toShowPaidHitAvailability.map((data, i) => {
                                                    return (
                                                        <PaidHitAvailabilityContent
                                                            key={`availability-item-${i}`}
                                                            {...data}
                                                        />
                                                    );
                                                })
                                            ) : 'Unknown'
                                            : 'Unknown'}
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="location show-ellipsis" data-testid={dataTestId && `${dataTestId}.desktop.location`}>{locationValue || ''}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`card-view ${isCardView ? 'd-block' : 'd-block d-md-none'}`}>
                    <div className="club-details">
                        <div className="d-flex align-self-stretch">
                            <div className="flex-grow">
                                <div className="row aifs">
                                    <div className="col-8">
                                        <div className="tag-container">
                                            {!!(force && force.featured) && <div className={`tag tag-featured tag-sm mr8`} data-testid={dataTestId && `${dataTestId}.featured-tag`}>Featured</div>}
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className={`avatar-wrapper`}>
                                            <BackgroundImage
                                                baseUrl={'/v1/club/'}
                                                defaultImage={'/img/v2/icons/icon-avatar-club.svg'}
                                                images={clubProfileImages}
                                                imageType={'profile'}
                                                parentStylesClass={'avatar'}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex-grow">
                            <div className="empty-div" />
                            <div className={`name`} data-testid={dataTestId && `${dataTestId}.mobile.name`}>
                                {<Dotdotdot clamp={2}>{name}</Dotdotdot>}
                            </div>

                            <div className={`${styles.mobileRatingView} show-ellipsis`}>
                                <span data-testid={dataTestId && `${dataTestId}.mobile.rating`}>
                                    {singlesRating || 'UR'} &nbsp;<span className="middle-dot" /> &nbsp;Singles
                                </span>
                            </div>
                            <div className={`${styles.mobileExperienceView} show-ellipsis`} data-testid={dataTestId && `${dataTestId}.mobile.playing-experience`}>
                                {playingExperience || ''}
                            </div>
                            <div className={`${styles.mobileExperienceView} show-ellipsis`} data-testid={dataTestId && `${dataTestId}.mobile.coaching-experience`}>
                                {coachingExperience || ''}
                            </div>
                            <div className="details show-ellipsis" data-testid={dataTestId && `${dataTestId}.mobile.location`}>{description}</div>
                        </div>
                    </div>
                </div>
            </div>
        </StatsigLink>
    );
};

PaidHitClubCard.defaultProps = {
    'data-testid': null,
};

export default PaidHitClubCard;
